import styled from "styled-components";
import { breakpoints } from '@authentic/loyalty-pwa/util/variables';

export const FooterStyle = styled.div`

  width: 95%;
  max-width: 1800px;
  margin: auto;
  
  @media print {
    display: none;
  }
`

export const LogoImg = styled.img`
  width: 85px;
`

export const DelTacoLogoStyle = styled.div`
  width: 100%;
  text-align: center;
  padding-top: 30px;
  margin-bottom: 22px;
`

export const DelTacoMenuStyle = styled.div`
  height: 30px;
  display: table;
  width: 95%;
  flex-direction: row;
  height: 30px;
  clear: both;
`

export const FooterMenu = styled.ul`
  width: 75%;
  float: left;
  display: flex;
  flex-wrap: wrap;
  text-align: left;
  list-style-type: none;
  padding-left: 0;

  & ul{
    padding: 0;
  }

  & >li{
    flex: 1;
    line-height: 2;

    @media screen and (max-width: ${breakpoints.md}){
      flex: none;
      width: 50%;
      line-height: 1.4;
      width: 50%;
      margin: 10px auto;
      padding: 0 5px;
    }

    &.two{
      flex: 2;
      @media screen and (max-width: ${breakpoints.md}){
        flex: none;
        width: 50%;
        line-height: 1.4;
        width: 50%;
        margin: 10px auto;
        padding: 0 5px;
      }
    }
  }

  a{
    text-transform: uppercase;
    font-family: "Nunito Sans","Nunito-Sans-Fallback",sans-serif;
    font-weight: 900;
    font-size: 0.9em;
    color: #000;
    text-decoration: none;
    list-style-type: none;

    :hover{
      color: #EF3340;
      text-decoration: underline;
    }

    @media (min-width: 48em){
      font-size: 0.8em;
    }

    @media (max-width: 37em){
      font-size: 0.6em;
    }
  }

  @media screen and (max-width: ${breakpoints.md}){
    width: 100%;
  }
`

export const SocialUl = styled.ul`

  display: flex;
  float: none;
  width: 25%;
  justify-content: center;
  align-items: center;
  margin: auto;
  padding: 20px 0;

  @media screen and (max-width: ${breakpoints.md}){
    width: 100%;
    justify-content: space-between;
  }

  li{
    flex: 1;
    text-align: center;
    justify-content: center;
    align-items: center;
    display: flex;
  }

  a{
    font-size: 3.5em;
    text-decoration: none;
    border: 2px solid #000;
    width: 53px;
    height: 53px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 26.5px;
    :hover{
      border: 2px solid #EF3340;
      svg {
        fill: #EF3340;
      }
    }
    svg {
      width: 27px;
    }
    
  }

  span{
    &.visually-hidden{
      position: absolute !important;
      clip: rect(1px,1px,1px,1px);
      padding: 0 !important;
      border: 0 !important;
      height: 1px !important;
      width: 1px !important;
      overflow: hidden;
    }
  }
`

export const DelTacoBottomMenuStyle = styled.div`

  width: 100%;
  text-align: right;
  float: left;
  padding-left: 16px;
  padding-right: 16px;
  margin-bottom: 20px;

  a{
    color: #000;
    font-size: 0.85em;
    text-transform: uppercase;
    font-family: "Nunito Sans","Nunito-Sans-Fallback",sans-serif;
    font-weight: 900;
    text-decoration: none;
    margin: 20px 10px;

    :hover{
      color: #EF3340;
      transform: scale(1);
      text-decoration: underline;
    }
  }

  @media screen and (max-width: ${breakpoints.md}){
    display: flex;
    justify-content: center;
  }

`

